export default __webpack_public_path__ + "static/media/email-query.ad7d327b.png";